import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { quizTopics } from "../../data/quizData";
import "./Quiz.css";

const QuizGame = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [score, setScore] = useState(0);
    const [showResult, setShowResult] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const [isAnswered, setIsAnswered] = useState(false);
    const [timeLeft, setTimeLeft] = useState(2); // For redirect countdown

    const topic = quizTopics.find((t) => t.id === id);

    useEffect(() => {
        if (!topic) {
            navigate("/quiz");
        }
    }, [topic, navigate]);

    // Auto-redirect effect when result is shown
    useEffect(() => {
        let timer;
        if (showResult) {
            timer = setInterval(() => {
                setTimeLeft((prev) => {
                    if (prev <= 1) {
                        clearInterval(timer);
                        navigate("/quiz");
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }
        return () => clearInterval(timer);
    }, [showResult, navigate]);

    if (!topic) return <div className="quiz-game-container">Loading...</div>;

    const currentQuestion = topic.questions[currentQuestionIndex];

    const handleOptionClick = (option) => {
        if (isAnswered) return;

        setSelectedOption(option);
        setIsAnswered(true);

        if (option === currentQuestion.correctAnswer) {
            setScore((prev) => prev + 1);
        }
    };

    const handleNextQuestion = () => {
        if (currentQuestionIndex < topic.questions.length - 1) {
            setCurrentQuestionIndex((prev) => prev + 1);
            setSelectedOption(null);
            setIsAnswered(false);
        } else {
            setShowResult(true);
        }
    };

    if (showResult) {
        return (
            <div className="quiz-game-container result-view" data-aos="zoom-in">
                <div className="result-card">
                    <h2>Quiz Completed!</h2>
                    <div className="score-display">
                        You scored <span>{score}/{topic.questions.length}</span>
                    </div>
                    <p>
                        {score === topic.questions.length
                            ? "Perfect! Ma-Sha-Allah!"
                            : score > topic.questions.length / 2
                                ? "Good job! Keep learning."
                                : "Keep trying, learning is a journey."}
                    </p>
                    <p style={{ marginTop: "20px", fontSize: "0.9rem", color: "#ccc" }}>
                        Redirecting to dashboard in {timeLeft}...
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="quiz-game-container">
            <div className="game-card" data-aos="fade-up">
                <div className="game-header">
                    <h3>{topic.title}</h3>
                    <span className="question-counter">
                        Question {currentQuestionIndex + 1} / {topic.questions.length}
                    </span>
                </div>

                <div className="question-section">
                    <h2>{currentQuestion.question}</h2>
                </div>

                <div className="options-section">
                    {currentQuestion.options.map((option, index) => {
                        let optionClass = "option-btn";
                        if (isAnswered) {
                            if (option === currentQuestion.correctAnswer) {
                                optionClass += " correct";
                            } else if (option === selectedOption) {
                                optionClass += " wrong";
                            }
                        }

                        return (
                            <button
                                key={index}
                                className={optionClass}
                                onClick={() => handleOptionClick(option)}
                                disabled={isAnswered}
                            >
                                {option}
                            </button>
                        );
                    })}
                </div>

                {isAnswered && (
                    <div className="next-section">
                        <button className="next-btn" onClick={handleNextQuestion}>
                            {currentQuestionIndex === topic.questions.length - 1 ? "Finish Quiz" : "Next Question"}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default QuizGame;
